import { FormAdditionalFields } from '../../../Form'

import { BankNameField } from './BankNameField'
import { BankOwnerField } from './BankOwnerField'
import { BICField } from './BICField'
import { BUILDING_FORM_ADDITIONAL_FIELDS_COUNT } from './BuildingFormAdditionalFields.constants'
import { IBANField } from './IBANField'

function BuildingFormAdditionalFields() {
  return (
    <FormAdditionalFields
      toggleVisibilityProps={{
        itemsCount: BUILDING_FORM_ADDITIONAL_FIELDS_COUNT,
        text: 'Building.ShowAdditionalBtnKey',
      }}
    >
      <IBANField />
      <BICField />
      <BankNameField />
      <BankOwnerField />
    </FormAdditionalFields>
  )
}

export default BuildingFormAdditionalFields
